export default {
      id: "txt_underline-usage",
      viewBox: "0 0 18 19",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#txt_underline",
      toString: function () {
        return this.url;
      }
    }